<template>
  <div class="bg-secondary-3 p-4">
    <div class="d-flex">
      <icon-view
        class="mt-5 mb-3 mt-md-0 mt-sm-5"
        :gradient="false"
        icon="file-circle-plus-icon"
        icon-background="#ff7058"
        icon-color="white"
        icon-size="14px"
        title="Añadir Documento"
      />
    </div>
    <validation-observer ref="formObserver">
      <div class="row p-2">
        <div class="col-md-6">
          <validation-provider v-slot="{ errors }" :rules="'required'">
            <custom-drop-down
              v-model="model.document"
              class="w-100"
              :custom-error-msg="'Favor seleccionar documento a añadir.'"
              :error="errors[0]"
              fieldkey="id"
              fieldname="displayName"
              label="Nombre del Documento:"
              :options="documentTypes"
              placeholder="Escriba un nombre existente de un documento"
              @input="onDocumentTypeChange()"
            />
          </validation-provider>
        </div>

        <div v-if="isOther" class="col-md-6">
          <validation-provider v-slot="{ errors }" :rules="'required'">
            <custom-input
              v-model="model.otherDocumentName"
              custom-error-msg="Favor especificar el nombre del documento a añadir."
              :error="errors[0]"
              label="Especifique Nombre del Documento:"
              type="text"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row p-2">
        <div class="col-md-12">
          <custom-text-area
            v-model="model.description"
            :disabled="!isOther"
            label="Descripción:"
            :maxlength="250"
            name="description"
            :rows="3"
          />
        </div>
      </div>
      <div class="row p-2">
        <div class="col-md-4">
          <div class="color-secondary-6 font-14">
            Requerido?:
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-radio
              id="isRequiredRb"
              v-model="model.required"
              class="custom-radio__extended"
              custom-error-msg="Favor indicar si documento será requerido."
              :error="Boolean(errors[0])"
              is-inline
              name="isRequiredRb"
              :options="requiredOptions"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <div class="color-secondary-6 font-14">
            Aplica a Proveedor:
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-radio
              id="providerApplicationRb"
              v-model="model.providerApplication"
              class="custom-radio__extended"
              custom-error-msg="Favor seleccionar a que tipo de proveedor aplica el documento."
              :error="Boolean(errors[0])"
              is-inline
              name="providerApplicationRb"
              :options="applicationProviderOptions"
            />
          </validation-provider>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3 pl-3 pr-4"
          @click="onCancelHandler"
        />
        <action-button
          i="fas fa-save"
          text="Guardar"
          variant="success pl-3 pr-3"
          @click="onSaveHandler"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import CustomRadio from 'custom-radio';
import CustomTextArea from 'CustomTextArea';
import IconView from 'icon-view';
import proposalDocumentProviderApplication from '@/utils/constants/proposalDocumentProviderApplication.js';
import documentTypes from '@/utils/constants/documentTypes.js';
import alertMixin from '@/mixins/alert.mixin.js';

export default {
  name: 'AddDocument',
  components: {
    ActionButton,
    CustomRadio,
    CustomTextArea,
    CustomDropDown,
    CustomInput,
    IconView,
  },
  mixins: [alertMixin],
  props: {
    documentTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      requiredOptions: [
        {
          id: 1,
          name: 'required-rb',
          value: true,
          label: 'Si',
          check: false,
          invalid: false,
          disabled: false,
        },
        {
          id: 2,
          name: 'required-rb',
          value: false,
          label: 'No',
          check: false,
          invalid: false,
          disabled: false,
        },
      ],
      applicationProviderOptions: [
        {
          id: proposalDocumentProviderApplication.Nuevo,
          name: 'required-rb',
          value: proposalDocumentProviderApplication.Nuevo,
          label: 'Nuevo',
          check: false,
          invalid: false,
          disabled: false,
        },
        {
          id: proposalDocumentProviderApplication.Existente,
          name: 'required-rb',
          value: proposalDocumentProviderApplication.Existente,
          label: 'Existente',
          check: false,
          invalid: false,
          disabled: false,
        },
        {
          id: proposalDocumentProviderApplication.Ambos,
          name: 'required-rb',
          value: proposalDocumentProviderApplication.Ambos,
          label: 'Ambos',
          check: false,
          invalid: false,
          disabled: false,
        },
      ],
      model: {
        document: null,
        otherDocumentName: null,
        required: null,
        providerApplication: null,
        description: null,
      },
    };
  },
  computed: {
    isOther() {
      return this.model.document?.realId == documentTypes.OtherProviderProposal;
    },
  },
  methods: {
    onCancelHandler() {
      this.$emit('on-cancel');
    },
    onDocumentTypeChange() {
      this.model.description = null;
      if (this.model.document && !this.isOther) {
        this.model.description = this.model.document.description;
      }
    },
    async onSaveHandler() {
      const isValid = await this.$refs.formObserver.validate();
      if (!isValid) {
        this.ShowToast(
          '',
          'Favor, debe completar los campos para continuar.',
          'error'
        );
        return;
      }

      this.$emit('on-create', {
        documentTypeId: this.model.document?.realId,
        providerApplication: this.model.providerApplication?.id,
        isCustomDocumentType: this.model.document?.isCustom,
        required: this.model.required.value,
        otherDocumentName: this.model.otherDocumentName,
        description: this.model.description,
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .dot {
    width: 32px !important;
    height: 32px !important;
  }

  .custom-radio__extended {
    .col-12 {
      padding: 0 !important;
    }
  }

  .ab-btn-success:disabled {
    background-color: #b5c3bc !important;
    border-color: #b5c3bc !important;
  }
}

.action-button__extended {
  margin-top: 1.85rem;
}
</style>
